<template>
    <PrivatePolicy />
</template>

<script setup>
import {
    onBeforeMount,
    onMounted,
    onUpdated,
    onUnmounted
} from "vue";
import { faLog } from "../common/faCommon.js";
import PrivatePolicy from "../components/PrivatePolicy.vue";

/**
 * VUE.js Methods...
 */
onBeforeMount(() => {
    faLog(0, "[PrivatePolicyView] [onBeforeMount]");
});

onMounted(() => {
    faLog(0, "[PrivatePolicyView] [onMounted]");
});

onUpdated(() => {
    faLog(0, "[PrivatePolicyView] [onUpdated]");
});

onUnmounted(() => {
    faLog(0, "[PrivatePolicyView] [onUnmounted]");
});
</script>
